import {dataMember, required} from 'santee-dcts';
import {EQueryAttachmentBase} from './e-query-attachment-base';

export class EQueryAttachment extends EQueryAttachmentBase {

    @dataMember()
    @required()
    public eQueryId: number;

    @dataMember()
    @required({nullable: true})
    public description: string;
}